// Librairies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Components
import { FieldInfoPipe } from 'src/app/pipes/field-info.pipe';

// A data field as the client reads it: its label with its technical name beside, in grey, then what it holds.
@Component({
  selector: 'app-field-label',
  standalone: true,
  imports: [FieldInfoPipe],
  templateUrl: './field-label.component.html',
  styleUrl: './field-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FieldLabelComponent {
  // Variables
  @Input({ required: true }) path: string = '';
  @Input() collection: string | null | undefined = 'metric';
  @Input() label: string | null | undefined;     // a custom label, over the glossary one
}
